"use strict";
/**
 * These types taken from Prisma to allow for a universal JSON type across packages.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=Json.js.map